import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { ReactElement } from 'react';
import type { NumberInputFrom } from '@tencent/wb-ext-form';

export interface IPictureCropFeature extends IBaseDrawerFeature {
    getPictureWidth(): number;
    getPictureHeight(): number;
    getPictureOffsetX(): number;
    getPictureOffsetY(): number;
    getCropWidth(): number;
    getCropHeight(): number;
    getCropLeft(): number;
    getCropTop(): number;
    handlePictureWidth(width: number, from: NumberInputFrom): void;
    handlePictureHeight(height: number, from: NumberInputFrom): void;
    handlePictureOffsetX(offsetX: number, from: NumberInputFrom): void;
    handlePictureOffsetY(offsetY: number, from: NumberInputFrom): void;
    handleCropWidth(width: number, from: NumberInputFrom): void;
    handleCropHeight(height: number, from: NumberInputFrom): void;
    handleCropLeft(left: number, from: NumberInputFrom): void;
    handleCropTop(top: number, from: NumberInputFrom): void;
    renderTailor(): ReactElement;
    shouldPicturePositionDisabled(): boolean;
}

export const IPictureCropFeature = Symbol.for('feature:drawer-picture-crop');

DynamicLoaderRegistry.merge(IPictureCropFeature, {
    useFactory: async () => {
        const { PictureCropFeature } = await import('./picture-crop-feature');
        return PictureCropFeature;
    },
    on: loadTask,
});
